import * as marietta from '../..';
import {
  BUILDING_TYPE_MANSION, MIN_INSTALLATION_HEIGHT_MM, MIN_ITEM_HEIGHT_MM,
} from '../Constants';
import { ItemController } from '../control';
import { MonicaObject } from '../item';

const ITEM_SIZE_DEPTH_INPUT_ID: string = 'itemSizeDepth';
const ITEM_SIZE_Z_INPUT_ID: string = 'itemSizeZ';
// 整数の mm だけを入力させるサイズ欄（W/D/H/Z）
const INTEGER_MM_INPUT_IDS: readonly string[] = ['itemSizeWidth', 'itemSizeHeight', ITEM_SIZE_DEPTH_INPUT_ID, ITEM_SIZE_Z_INPUT_ID];

/**
 * Control panel to edit item properties
 * */
export default class ItemControlPanel {
  ItemControlPanelWrap: HTMLElement;

  ItemControlPanelHeader: HTMLElement;

  panelOffset: marietta.core.Point;

  panelPosition: marietta.core.Point;

  currentState: string;

  siteRotation: number = 0;

  siteRotateTimer: any;

  siteRotationtimePassed: number;

  /** 位置揃え */
  protected itemAlignView: HTMLElement;

  /**
   * コンストラクタ
   */
  constructor() {
    const self = this;

    // パネル全体を格納
    this.ItemControlPanelWrap = document.getElementById('itemControlPanel');

    // パネルの移動 初期化
    this.panelOffset = new marietta.core.Point(0, 0);
    this.panelPosition = new marietta.core.Point(0, 0);
    this.ItemControlPanelHeader = document.getElementById('itemControlPanel_header');

    // パネル表示初期化
    if (!marietta.webcad.WebCADGlobal.itemManager || !marietta.webcad.WebCADGlobal.itemManager.currentItem) {
      this.ItemControlPanelWrap.style.display = 'none';
    }

    // ロックボタン初期化
    document.getElementById('toggleLock').addEventListener('click', self.lockToggle);

    // コピー初期化
    document.getElementById('btnCopy').addEventListener('click', self.itemCopy);

    // ペースト初期化
    document.getElementById('btnPaste').addEventListener('click', self.itemPaste);

    // 前面・背面移動ボタン初期化
    document.getElementById('btnFront').addEventListener('click', self.moveFront);
    document.getElementById('btnBack').addEventListener('click', self.moveBack);
    document.getElementById('btnTop').addEventListener('click', self.moveTop);
    document.getElementById('btnBottom').addEventListener('click', self.moveBottom);

    // 回転ボタン初期化
    document.getElementById('btnRotateL').addEventListener('click', self.rotateItem);
    document.getElementById('btnRotateR').addEventListener('click', self.rotateItem);

    // サイト回転ボタン初期化
    const ua = marietta.webcad.WebCADGlobal.userAgentManager;
    if (ua.isMobile || ua.isTablet) {
      document.getElementById('btnRotateLSite').addEventListener('touchstart', self.onMouseDownRotateSite);
      document.getElementById('btnRotateRSite').addEventListener('touchstart', self.onMouseDownRotateSite);
    } else {
      document.getElementById('btnRotateLSite').addEventListener('mousedown', self.onMouseDownRotateSite);
      document.getElementById('btnRotateRSite').addEventListener('mousedown', self.onMouseDownRotateSite);
    }

    // 反転ボタン初期化
    document.getElementById('btnReverse').addEventListener('click', self.reverseItem);

    // アイテムサイズボックス初期化
    document.getElementById('itemSizeWidth').addEventListener('change', self.changeItemSize);
    document.getElementById('itemSizeHeight').addEventListener('change', self.changeItemSize);
    document.getElementById(ITEM_SIZE_DEPTH_INPUT_ID).addEventListener('change', self.changeItemSize);
    document.getElementById(ITEM_SIZE_Z_INPUT_ID).addEventListener('change', self.changeItemSize);
    // サイズ・設置高さは整数の mm。「-」や小数点を打てないようにする
    INTEGER_MM_INPUT_IDS.forEach((inputId: string) => {
      marietta.webcad.util.InputValidationUtil.setIntegerMmFilter(<HTMLInputElement>document.getElementById(inputId));
    });

    document.getElementById('itemInstallationHeight').addEventListener('change', self.changeItemHeight);

    // 色変更ボタン初期化
    document.getElementById('btnRoomColor').addEventListener('click', self.changeRoomColor);

    // 部屋種類変更ボタン初期化
    document.getElementById('btnChangeRoom').addEventListener('click', self.changeRoomType);

    // 名前設定ボタン初期化
    document.getElementById('btnRoomTextSetting').addEventListener('click', self.showRoomTextSetting);

    // 建具種類変更ボタン初期化
    document.getElementById('btnFittingChange').addEventListener('click', self.changeFittingType);

    // 名前設定ボタン初期化
    document.getElementById('btnItemTextSetting').addEventListener('click', self.showItemTextSetting);

    // 部屋の頂点追加
    document.getElementById('btnAddPoint').addEventListener('click', self.startRoomEditAdd);

    // 部屋のテキスト移動
    document.getElementById('btnMoveText').addEventListener('click', self.startRoomTextMove);

    // 部屋の壁追加
    document.getElementById('btnAddWall').addEventListener('click', self.startRoomEditAddWall);

    // 部屋の壁削除
    document.getElementById('btnRemoveWall').addEventListener('click', self.startRoomEditRemoveWall);

    // 汎用作図の文字設定
    document.getElementById('btnTextSetting').addEventListener('click', self.showTextSetting);

    // サイズ変更ボタン（ダイアログの表示）
    if (document.getElementById('btnItemSizeControl')) {
      document.getElementById('btnItemSizeControl').addEventListener('click', self.showItemSizeChangeDialog);
    }

    // 削除ボタン初期化
    document.getElementById('btnDelete').addEventListener('click', self.deleteItem);

    // 建具設定
    document.getElementById('btnSetting').addEventListener('click', self.showSetting);
    document.getElementById('btnSettingRom').addEventListener('click', self.showSetting);

    document.getElementById('btnLockAll').addEventListener('click', () => {
      marietta.webcad.WebCADGlobal.itemManager.lockAll(true);
    });
    document.getElementById('btnUnLockAll').addEventListener('click', () => {
      marietta.webcad.WebCADGlobal.itemManager.lockAll(false);
    });

    document.getElementById('btnShowAllRoomNames').addEventListener('click', () => {
      marietta.webcad.WebCADGlobal.itemManager.showAllRoomNames(true);
    });
    document.getElementById('btnHideAllRoomNames').addEventListener('click', () => {
      marietta.webcad.WebCADGlobal.itemManager.showAllRoomNames(false);
    });

    document.querySelectorAll('.dialogCloseBtn').forEach((element) => {
      element.addEventListener('click', () => {
        marietta.webcad.WebCADGlobal.itemChangeMenuCategories3d.reset();
      });
    });
    document.getElementById('btnChangeRoofShape').addEventListener('click', () => {
      marietta.webcad.WebCADGlobal.itemChangeMenuCategories3d.reset();
    });
    document.getElementById('btnCancelRoofShape').addEventListener('click', () => {
      marietta.webcad.WebCADGlobal.itemChangeMenuCategories3d.reset();
    });
    document.getElementById('btnChangeModel3d').addEventListener('click', () => {
      marietta.webcad.WebCADGlobal.itemChangeMenuCategories3d.reset();
    });
    document.getElementById('btnCancelModel3d').addEventListener('click', () => {
      marietta.webcad.WebCADGlobal.itemChangeMenuCategories3d.reset();
    });

    document.getElementById('btnResetAllRoof').addEventListener('click', () => {
      marietta.webcad.WebCADGlobal.resetAllRoofAndReload3D();
    });

    document.getElementById('show1F_2d').addEventListener('click', () => {
      marietta.webcad.WebCADGlobal.changeFloor(1);
    });
    document.getElementById('show2F_2d').addEventListener('click', () => {
      marietta.webcad.WebCADGlobal.changeFloor(2);
    });
    document.getElementById('show3F_2d').addEventListener('click', () => {
      marietta.webcad.WebCADGlobal.changeFloor(3);
    });

    // デフォルトで整列メニューを無効にする
    document.getElementById('headerMenuAlign').classList.add('disabled');
    document.getElementById('btn-item-align-horizontal').classList.add('disabled');
    document.getElementById('btn-item-align-vertical').classList.add('disabled');

    // トリガーhandlerChangeposMenu関数。整列メニューサブメニューの表示/非表示に使用
    document.getElementById('headerMenuAlign').addEventListener('click', self.handlerChangeposMenu);

    // alignment subMenu jQueryオブジェクトの割り当て
    this.itemAlignView = document.getElementById('w2p-item-align-view');
    // alignmentサブメニューのクリック機能のトリガー
    document.getElementById('btn-item-align-top').addEventListener('click', self.handlerItemAlignTop);
    document.getElementById('btn-item-align-bottom').addEventListener('click', self.handlerItemAlignBottom);
    document.getElementById('btn-item-align-middle').addEventListener('click', self.handlerItemAlignMiddle);
    document.getElementById('btn-item-align-left').addEventListener('click', self.handlerItemAlignLeft);
    document.getElementById('btn-item-align-right').addEventListener('click', self.handlerItemAlignRight);
    document.getElementById('btn-item-align-center').addEventListener('click', self.handlerItemAlignCenter);
    document.getElementById('btn-item-align-vertical').addEventListener('click', self.handlerItemAlignVertical);
    document.getElementById('btn-item-align-horizontal').addEventListener('click', self.handlerItemAlignHorizontal);
  }

  // 整列メニューサブメニューの表示/非表示に使用
  private handlerChangeposMenu: () => void = (): void => {
    this.onClickMenuChangeposButton();
  };

  // 位置合わせサブメニューのクリック機能
  private handlerItemAlignTop: () => void = (): void => {
    this.onMenuItemAlignTop();
  };

  // align item to bottom
  private handlerItemAlignBottom: () => void = (): void => {
    this.onMenuItemAlignBottom();
  };

  // align item to middle
  private handlerItemAlignMiddle: () => void = (): void => {
    this.onMenuItemAlignMiddle();
  };

  // align item to left
  private handlerItemAlignLeft: () => void = (): void => {
    this.onMenuItemAlignLeft();
  };

  // align item to right
  private handlerItemAlignRight: () => void = (): void => {
    this.onMenuItemAlignRight();
  };

  // align item to center
  private handlerItemAlignCenter: () => void = (): void => {
    this.onMenuItemAlignCenter();
  };

  // align item to verical
  private handlerItemAlignVertical: () => void = (): void => {
    this.onMenuItemAlignVertical();
  };

  // align item to horizontal
  private handlerItemAlignHorizontal: () => void = (): void => {
    this.onMenuItemAlignHorizontal();
  };

  /**
   * 位置揃え：上
   * @param e イベント情報
   */
  protected onMenuItemAlignTop(): void {
    ItemController.align('top');
    this.hideView(this.itemAlignView);
  }

  /**
   * 位置揃え：下
   * @param e イベント情報
   */
  protected onMenuItemAlignBottom(): void {
    ItemController.align('bottom');
    this.hideView(this.itemAlignView);
  }

  /**
   * 位置揃え：上下中央
   * @param e イベント情報
   */
  protected onMenuItemAlignMiddle(): void {
    ItemController.align('verticalCenter');
    this.hideView(this.itemAlignView);
  }

  /**
   * 位置揃え：左
   * @param e イベント情報
   */
  protected onMenuItemAlignLeft(): void {
    ItemController.align('left');
    this.hideView(this.itemAlignView);
  }

  /**
   * 位置揃え：右
   * @param e イベント情報
   */
  protected onMenuItemAlignRight(): void {
    ItemController.align('right');
    this.hideView(this.itemAlignView);
  }

  /**
   * 位置揃え：左右中央
   * @param e イベント情報
   */
  protected onMenuItemAlignCenter(): void {
    ItemController.align('horizontalCenter');
    this.hideView(this.itemAlignView);
  }

  /**
   * 位置揃え：上下均等
   * @param e イベント情報
   */
  protected onMenuItemAlignVertical(): void {
    ItemController.equalAlign('vertical');
    this.hideView(this.itemAlignView);
  }

  /**
   * 位置揃え：左右均等
   * @param e イベント情報
   */
  protected onMenuItemAlignHorizontal(): void {
    ItemController.equalAlign('horizontal');
    this.hideView(this.itemAlignView);
  }

  /**
   * 位置揃えメニュークリック
   * @param e イベント情報
   */
  protected onClickMenuChangeposButton() {
    if (this.isShown(this.itemAlignView)) {
      this.hideView(this.itemAlignView);
    } else {
      this.showView(this.itemAlignView);
    }
  }

  /**
   * エレメント非表示
   * @param view 非表示するエレメント
   */
  protected hideView = (view: HTMLElement): void => {
    if (view) {
      view.classList.remove('pull-down-show');
    }
  };

  /**
   * エレメント表示
   * @param view 表示するエレメント
   */
  protected showView = (view: HTMLElement): void => {
    if (view) {
      view.classList.add('pull-down-show');
    }
  };

  /**
   * エレメント表示判定
   * @param view 判定するエレメント
   */
  protected isShown = (view: HTMLElement): boolean => {
    if (view) {
      return view.classList.contains('pull-down-show');
    }
    return null;
  };

  /**
   * マウスダウンされた
   * @param MouseEvent
   */
  onMouseDownRotateSite = (e: Event) => {
    e.preventDefault();
    // 回転の開始
    let direction: string;
    if ((<HTMLElement>e.currentTarget).getAttribute('id') === 'btnRotateLSite') {
      direction = 'left';
    } else {
      direction = 'right';
    }

    if (marietta.webcad.WebCADGlobal.userAgentManager.isMobile || marietta.webcad.WebCADGlobal.userAgentManager.isTablet) {
      document.addEventListener('touchend', this.onMouseUpRotateSite, { passive: false });
    } else {
      document.addEventListener('mouseup', this.onMouseUpRotateSite);
    }

    if ((marietta.webcad.WebCADGlobal.itemManager.currentItem != null && marietta.webcad.WebCADGlobal.itemManager.currentItem.isCapableOfRotate()) || (marietta.webcad.WebCADGlobal.itemManager.currentItemGroup != null && marietta.webcad.WebCADGlobal.itemManager.currentItemGroup.isCapableOfRotate())) {
      this.siteRotateTimer = setInterval(() => this.rotateSite(direction), 50);
    }
    this.siteRotationtimePassed = 0;
  };

  /**
   * マウスがUPされた
   */
  onMouseUpRotateSite = (e: Event) => {
    e.preventDefault();
    if (marietta.webcad.WebCADGlobal.userAgentManager.isMobile || marietta.webcad.WebCADGlobal.userAgentManager.isTablet) {
      document.removeEventListener('touchend', this.onMouseUpRotateSite);
    } else {
      document.removeEventListener('mouseup', this.onMouseUpRotateSite);
    }

    clearInterval(this.siteRotateTimer);

    marietta.webcad.WebCADGlobal.webcad2Dmanager.saveToHistory();
  };

  /**
   * 回転
   */
  rotateSite(direction: string) {
    this.siteRotationtimePassed += 50;
    let sokudo: number = 1;

    // 時間と共に回転を早くする
    if (this.siteRotationtimePassed > 3000) {
      sokudo = 10;
    } else if (this.siteRotationtimePassed > 1000) {
      sokudo = 4;
    } else if (this.siteRotationtimePassed > 500) {
      sokudo = 2;
    }
    let currentItem: any;
    let angle: number;
    let itemController: any;
    if (marietta.webcad.WebCADGlobal.itemManager.currentItem != null && marietta.webcad.WebCADGlobal.itemManager.currentItem !== undefined) {
      currentItem = marietta.webcad.WebCADGlobal.itemManager.currentItem;
      // アイテムの回転
      angle = currentItem.itemInfo.rotation;
      if (direction === 'left') {
        angle -= sokudo;
      } else {
        angle += sokudo;
      }
      if (angle >= 360) angle %= 360;
      if (angle < 0) angle += 360;
      if (currentItem instanceof marietta.webcad.item.Site) {
        itemController = marietta.webcad.WebCADGlobal.itemManager.itemController;
        itemController.rotateItem(angle);
      }

      // アイテムコントローラー更新
      marietta.webcad.WebCADGlobal.itemManager.currentItem = currentItem;
    } else if (marietta.webcad.WebCADGlobal.itemManager.currentItemGroup != null && marietta.webcad.WebCADGlobal.itemManager.currentItemGroup !== undefined) {
      currentItem = marietta.webcad.WebCADGlobal.itemManager.currentItemGroup;
      // アイテムの回転
      if (direction === 'left') {
        currentItem.rotate(-sokudo);
      } else {
        currentItem.rotate(sokudo);
      }
    }
  }

  /**
   * パネルの移動
   */
  headerEventHandlerMouseDown = (e: MouseEvent) => {
    e.preventDefault();

    let ua = marietta.webcad.WebCADGlobal.userAgentManager;
    if (ua.isMobile || ua.isTablet) {
      // パネルのクリック位置格納
      this.panelOffset.x = e.pageX;
      this.panelOffset.y = e.pageY;
      document.addEventListener('touchmove', this.headerEventHandlerMouseMove, { passive: false });
      document.addEventListener('touchend', this.headerEventHandlerMouseUp, { passive: false });
    } else {
      // パネルのクリック位置格納
      this.panelOffset.x = e.clientX;
      this.panelOffset.y = e.clientY;
      document.addEventListener('mousemove', this.headerEventHandlerMouseMove);
      document.addEventListener('mouseup', this.headerEventHandlerMouseUp);
    }
    ua = null;
  };

  /**
   * handle mouse move while dragging panel
   */
  headerEventHandlerMouseMove = (e: MouseEvent) => {
    e.preventDefault();
    let posX;
    let posY;
    const ua = marietta.webcad.WebCADGlobal.userAgentManager;
    if (ua.isMobile || ua.isTablet) {
      posX = e.pageX - this.panelOffset.x + this.panelPosition.x;
      posY = e.pageY - this.panelOffset.y + this.panelPosition.y;
    } else {
      posX = e.clientX - this.panelOffset.x + this.panelPosition.x;
      posY = e.clientY - this.panelOffset.y + this.panelPosition.y;
    }
    const cssTransform = `translate(${posX}px,${posY}px)`;
    this.ItemControlPanelWrap.style.transform = cssTransform;
  };

  /**
   * handle mouse up after dragging panel
   */
  headerEventHandlerMouseUp = (e: MouseEvent) => {
    e.preventDefault();
    // transformで移動したパネルの配置格納
    const cssVal: string = this.ItemControlPanelWrap.style.transform;
    const cssValTemp: string[] = cssVal.split(', ');
    this.panelPosition.x = parseInt(cssValTemp[4], 10);
    this.panelPosition.y = parseInt(cssValTemp[5].split(')')[0], 10);

    if (marietta.webcad.WebCADGlobal.userAgentManager.isMobile || marietta.webcad.WebCADGlobal.userAgentManager.isTablet) {
      document.removeEventListener('touchmove', this.headerEventHandlerMouseMove);
      document.removeEventListener('touchend', this.headerEventHandlerMouseUp);
    } else {
      document.removeEventListener('mousemove', this.headerEventHandlerMouseMove);
      document.removeEventListener('mouseup', this.headerEventHandlerMouseUp);
    }
  };

  /**
   * 情報をセットする
   */
  public setInfo() {
    // 整列メニューを無効にする
    document.getElementById('headerMenuAlign').classList.add('disabled');
    document.getElementById('btn-item-align-horizontal').classList.add('disabled');
    document.getElementById('btn-item-align-vertical').classList.add('disabled');
    this.hideView(this.itemAlignView);
    const { currentItem } = marietta.webcad.WebCADGlobal.itemManager;
    const { currentItemGroup } = marietta.webcad.WebCADGlobal.itemManager;

    // 初期化
    this.ItemControlPanelWrap.style.display = 'none';

    // カレントがある場合
    if (currentItem) {
      // パネルを表示
      this.ItemControlPanelWrap.style.display = '';

      // アイテムの種類を判別
      let showCommonSet = true;
      const tarID = currentItem.itemInfo.id;
      switch (tarID.substring(0, 3)) {
        case 'sit':
          this.currentState = 'site';
          break;
        case 'str':
          this.currentState = 'stair';
          break;
        case 'col':
          this.currentState = 'column';
          break;
        case 'rom':
          this.currentState = 'room';
          break;
        case 'fit':
          this.currentState = 'fitting';
          break;
        case 'rof':
          this.currentState = 'roof';
          showCommonSet = false;
          break;
        case 'wal':
          this.currentState = 'wal';
          break;
        case 'bem':
          this.currentState = 'beam';
          break;
        case 'txt':
          this.currentState = 'text';
          showCommonSet = false;
          break;
        case 'equ':
        case 'fur':
        case 'ext':
        case 'gui':
        case 'pnt':
        case 'mrk':
          this.currentState = 'other';
          break;
        default:
          console.error('アイテムの種類が取得できません。');
          break;
      }

      // パネル内のボタン表示初期化
      this.ItemControlPanelWrap.querySelectorAll('.itemControlPanel_nav').forEach((element) => {
        element.setAttribute('style', 'display : none');
      });
      if (showCommonSet) {
        this.ItemControlPanelWrap.querySelectorAll('.commonSet').forEach((element) => {
          element.setAttribute('style', 'display : " "');
        });
      }
    } else if (currentItemGroup) {
      // パネルを表示
      this.ItemControlPanelWrap.style.display = '';
      if (currentItemGroup.myItemList.length > 0 && currentItemGroup.myItemList[0] instanceof marietta.webcad.item.Site) {
        this.currentState = 'site';
        this.ItemControlPanelWrap.style.display = '';
        // パネル内のボタン表示初期化
        this.ItemControlPanelWrap.querySelectorAll('.itemControlPanel_nav').forEach((element) => {
          element.setAttribute('style', 'display : none');
        });
      } else {
        this.currentState = 'group';
        // パネル内のボタン表示初期化
        this.ItemControlPanelWrap.querySelectorAll('.itemControlPanel_nav').forEach((element) => {
          element.setAttribute('style', 'display : none');
        });
      }
      // グループアイテムでのチェックは調整可能です。 GroupItemにEquipmentItemとFurnitureItemのみが含まれる場合、位置合わせが可能です。
      // 整列メニューの無効化/有効化
      if (marietta.webcad.WebCADGlobal.itemManager.currentItemGroup.isCapableOfAlign() && currentItemGroup.myItemList.length > 1) {
        document.getElementById('headerMenuAlign').classList.remove('disabled');
        if (currentItemGroup.myItemList.length > 2) {
          document.getElementById('btn-item-align-horizontal').classList.remove('disabled');
          document.getElementById('btn-item-align-vertical').classList.remove('disabled');
        }
      } else {
        document.getElementById('headerMenuAlign').classList.add('disabled');
        document.getElementById('btn-item-align-horizontal').classList.add('disabled');
        document.getElementById('btn-item-align-vertical').classList.add('disabled');
      }

      //グループの中が全部、部屋だったら、部屋設定を表示する
      if( currentItemGroup.myItemList.length == currentItemGroup.myItemList.filter((val: MonicaObject) => 'rom' == val.itemInfo.id.substring(0,3)).length ){
        (document.getElementById('btnSettingRom').parentElement).setAttribute('style', 'display : ""');
      }
    } else {
      return;
    }

    // アイテムの種類に応じてパネルメニューを変更
    const panelBtnSet = `.${this.currentState}Set`;
    if (this.ItemControlPanelWrap.querySelectorAll(panelBtnSet).length > 0) {
      this.ItemControlPanelWrap.querySelectorAll(panelBtnSet).forEach((element) => {
        element.setAttribute('style', 'display : ""');
      });
    }
    if (marietta.webcad.WebCADGlobal.itemManager.currentItem) {
      if (marietta.webcad.WebCADGlobal.itemManager.currentItem.isHeightEditableItem()) {
        if (document.querySelector('#footer .itemControlPanel_nav .forGeneralPurposeItem')) {
          document.querySelectorAll('#footer .itemControlPanel_nav .forGeneralPurposeItem').forEach((element) => {
            element.setAttribute('style', 'display : inline-block');
          });
        }
      } else {
        if (document.querySelector('#footer .itemControlPanel_nav .forGeneralPurposeItem')) {
          document.querySelectorAll('#footer .itemControlPanel_nav .forGeneralPurposeItem').forEach((element) => {
            element.setAttribute('style', 'display : none');
          });
        }
      }
    } else {
      if (document.querySelector('#footer .itemControlPanel_nav .forGeneralPurposeItem')) {
        document.querySelectorAll('#footer .itemControlPanel_nav .forGeneralPurposeItem').forEach((element) => {
          element.setAttribute('style', 'display : none');
        });
      }
    }
    // パネルの情報更新
    this.panelUpdate();
  }

  /**
   * アイテムをロック/アンロック
   */
  lockToggle = (e: Event) => {
    e.preventDefault();

    if (marietta.webcad.WebCADGlobal.itemManager.currentItem.itemInfo.lock) {
      marietta.webcad.WebCADGlobal.itemManager.itemLock(marietta.webcad.WebCADGlobal.itemManager.currentItem, false);
    } else {
      marietta.webcad.WebCADGlobal.itemManager.itemLock(marietta.webcad.WebCADGlobal.itemManager.currentItem, true);
    }

    this.panelUpdate();
  };

  /**
   * パネル更新
   */
  panelUpdate() {
    // パネルの位置修正
    const w = document.getElementById('itemControlPanel').getBoundingClientRect().width;
    document.getElementById('itemControlPanel').style.marginLeft = `${Math.floor(-w / 2)}px`;

    // パネルのロック状態処理
    const { currentItem } = marietta.webcad.WebCADGlobal.itemManager;
    if (marietta.webcad.WebCADGlobal.itemManager.currentItem === undefined || marietta.webcad.WebCADGlobal.itemManager.currentItem == null) {
      // グループの場合
      if (marietta.webcad.WebCADGlobal.itemManager.currentItemGroup != null && marietta.webcad.WebCADGlobal.itemManager.currentItemGroup !== undefined) {
        if (!marietta.webcad.WebCADGlobal.itemManager.currentItemGroup.isCapableOfRotate()) {
          (<HTMLInputElement>document.getElementById('btnRotateL')).disabled = true;
          (<HTMLInputElement>document.getElementById('btnRotateR')).disabled = true;
          (<HTMLInputElement>document.getElementById('btnRotateLSite')).disabled = true;
          (<HTMLInputElement>document.getElementById('btnRotateRSite')).disabled = true;
        } else {
          (<HTMLInputElement>document.getElementById('btnRotateL')).disabled = false;
          (<HTMLInputElement>document.getElementById('btnRotateR')).disabled = false;
          (<HTMLInputElement>document.getElementById('btnRotateLSite')).disabled = false;
          (<HTMLInputElement>document.getElementById('btnRotateRSite')).disabled = false;
        }
        if (!marietta.webcad.WebCADGlobal.itemManager.currentItemGroup.isCapableOfReverse()) {
          (<HTMLInputElement>document.getElementById('btnReverse')).disabled = true;
        } else {
          (<HTMLInputElement>document.getElementById('btnReverse')).disabled = false;
        }
        if (document.getElementById('btnJoin') !== null) {
          if (!marietta.webcad.WebCADGlobal.itemManager.currentItemGroup.isCapableOfRoomJoin()) {
            (<HTMLInputElement>document.getElementById('btnJoin')).disabled = true;
          } else {
            (<HTMLInputElement>document.getElementById('btnJoin')).disabled = false;
          }
        }
      }

      return;
    }

    const lockBtn = document.getElementById('toggleLock');

    // アイテムがロックされていないとき
    if (!marietta.webcad.WebCADGlobal.itemManager.currentItem.itemInfo.lock) {
      // ロックアイコンを変更
      lockBtn.querySelectorAll('.icon').forEach((element) => {
        element.classList.remove('icon-lock');
        element.classList.add('icon-unlock');
      });
      // その他のパネル操作を有効化
      const btns = this.ItemControlPanelWrap.getElementsByTagName('button');
      const inputs = this.ItemControlPanelWrap.getElementsByTagName('input');
      for (let i = 0, len = btns.length; i < len; i += 1) {
        btns[i].removeAttribute('disabled');
      }
      for (let i = 0, len = inputs.length; i < len; i += 1) {
        inputs[i].removeAttribute('disabled');
      }
      // AutoFacingアイテムは回転ボタンを見せない
      if (marietta.webcad.WebCADGlobal.isAutoFacingItem(currentItem.itemInfo.id)) {
        (<HTMLInputElement>document.getElementById('btnRotateL')).disabled = true;
        (<HTMLInputElement>document.getElementById('btnRotateR')).disabled = true;
      } else {
        (<HTMLInputElement>document.getElementById('btnRotateL')).disabled = false;
        (<HTMLInputElement>document.getElementById('btnRotateR')).disabled = false;
      }

      // 建具でかつ高さ設定できないアイテムは、設定ボタンを表示しない
      if (marietta.webcad.WebCADGlobal.isHeightSettingEnableFitting(currentItem.itemInfo.id)) {
        (<HTMLInputElement>document.getElementById('btnSetting')).disabled = false;
      } else if (marietta.webcad.WebCADGlobal.isHeightSettingEnableWall(currentItem.itemInfo.id)) {
        (<HTMLInputElement>document.getElementById('btnSetting')).disabled = false;
      } else {
        (<HTMLInputElement>document.getElementById('btnSetting')).disabled = true;
      }

      // サイズの下限を更新（下限は住設・家具だけ 1mm）。値は refreshSize で入れる
      const minPlanSize: string = currentItem.getMinPlanSizeMM().toString();
      (<HTMLInputElement>document.getElementById('itemSizeWidth')).min = minPlanSize;
      (<HTMLInputElement>document.getElementById('itemSizeHeight')).min = minPlanSize;

      const isCelingItem = marietta.webcad.WebCADGlobal.ceilingItemCodeList.includes(currentItem.itemInfo.id);
      const isWallItem = marietta.webcad.WebCADGlobal.doesItemSupportZPositioning(currentItem.itemInfo.id);
      // 高さ編集対象はサイズ欄の Z で設置高さを編集するため、設置高さ欄は出さない
      if (!isCelingItem && isWallItem && !currentItem.isHeightEditableItem()) {
        (<HTMLInputElement>document.getElementById('itemInstallationHeight')).value = currentItem.itemInfo.z.toString();
      } else if (currentItem.isPinPictureItem()) {
        (<HTMLInputElement>document.getElementById('itemInstallationHeight')).value = currentItem.itemInfo.transformMatrix[13].toString();
      } else {
        (<HTMLInputElement>document.getElementById('itemInstallationHeightContainer')).style.display = 'none'
      }

      // ホワイトアイテム以外はサイズ変更できない
      if (!currentItem.itemInfo.isWhiteItem()) {
        (<HTMLInputElement>document.getElementById('itemSizeWidth')).disabled = true;
        (<HTMLInputElement>document.getElementById('itemSizeHeight')).disabled = true;
        (<HTMLInputElement>document.getElementById(ITEM_SIZE_DEPTH_INPUT_ID)).disabled = true;
        if (document.getElementById('btnItemSizeControl')) {
          (<HTMLInputElement>document.getElementById('btnItemSizeControl')).disabled = true;
        }
      } else {
        (<HTMLInputElement>document.getElementById('itemSizeWidth')).disabled = false;
        (<HTMLInputElement>document.getElementById('itemSizeHeight')).disabled = false;
        (<HTMLInputElement>document.getElementById(ITEM_SIZE_DEPTH_INPUT_ID)).disabled = false;
        if (document.getElementById('btnItemSizeControl')) {
          (<HTMLInputElement>document.getElementById('btnItemSizeControl')).disabled = false;
        }
      }

      // 建具は、エンドアイテム設定されていれば、アイテム種類変更の機能が切り替る
      if (-1 < currentItem.itemInfo.id.indexOf('fit')){
        (<HTMLInputElement>document.getElementById('btnFittingChange')).disabled = !!currentItem.itemInfo.end_item_info;
      }
    } else {
      // アイテムがロックされているとき
      // ロックアイコンを変更
      lockBtn.querySelectorAll('.icon').forEach((element) => {
        element.classList.remove('icon-lock');
        element.classList.add('icon-unlock');
      });
      this.disableFooterControlButtons();
      lockBtn.removeAttribute('disabled');
    }

    // サイズの値（ロック中も、入力は無効のまま値を出す）
    this.refreshSize();

    // マンションモード時の部屋メニュー
    if (marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType === 1 && currentItem instanceof marietta.webcad.item.Room) {
      document.querySelectorAll('#footer .itemControlPanel_nav.commonSet')[0].setAttribute('style', 'display : none');
      document.querySelectorAll('#footer .itemControlPanel_nav.commonSet')[1].setAttribute('style', 'display : none');
      document.querySelector('#footer .itemControlPanel_nav.roomSet').setAttribute('style', 'display : none');
      const w2 = document.getElementById('itemControlPanel').getBoundingClientRect().width;
      document.getElementById('itemControlPanel').style.marginLeft = `${Math.floor(-w2 / 2)}px`;
    }

    // シェアモードでは値の確認のみとするため、入力を無効化する
    // （上のロック状態の処理で disabled が解除されるため、最後に設定する）
    if (marietta.webcad.WebCADGlobal.shareModeManager.isShareMode) {
      const shareModeInputs = this.ItemControlPanelWrap.getElementsByTagName('input');
      for (let i = 0, len = shareModeInputs.length; i < len; i += 1) {
        shareModeInputs[i].setAttribute('disabled', 'disabled');
      }
      // 設置高さは内部座標をそのまま表示すると端数が出るため、四捨五入した整数にする
      const installationHeightInput = <HTMLInputElement>document.getElementById('itemInstallationHeight');
      if (installationHeightInput && installationHeightInput.value !== '') {
        installationHeightInput.value = Math.round(Number(installationHeightInput.value)).toString();
      }
    }
  }

  /**
   * サイズ欄（W/D/H/Z）に選んでいるアイテムの値を入れる。操作の確定のたびにも呼ぶ（Plan2DManager）
   * 入力中の欄は上書きしない。選択が無い・グループのときは何もしない
   */
  public refreshSize(): void {
    const { currentItem } = marietta.webcad.WebCADGlobal.itemManager;
    if (!currentItem) return;
    const size: { width: number, depth: number, height: number } = marietta.webcad.WebCADGlobal.getItemSize(currentItem.itemInfo);
    const values: { [inputId: string]: number } = {
      itemSizeWidth: size.width,
      itemSizeHeight: size.depth,
      [ITEM_SIZE_DEPTH_INPUT_ID]: size.height,
      [ITEM_SIZE_Z_INPUT_ID]: currentItem.itemInfo.z,
    };
    Object.keys(values).forEach((inputId: string) => {
      const input: HTMLInputElement = document.getElementById(inputId) as HTMLInputElement;
      if (!input || input === document.activeElement) return;
      // Z は未設定なら 0、ほかは 0・未設定なら空欄（前に選んだアイテムの値を残さない）
      const value: number = values[inputId];
      if (inputId === ITEM_SIZE_Z_INPUT_ID) {
        input.value = (value || 0).toString();
      } else {
        input.value = value > 0 ? value.toString() : '';
      }
    });
  }

  /**
   * disable footer control buttons
   */
  disableFooterControlButtons() {
    // すべてのフッターコントロールボタンを無効にする
    const btns = this.ItemControlPanelWrap.getElementsByTagName('button');
    const inputs = this.ItemControlPanelWrap.getElementsByTagName('input');
    for (let i = 0, len = btns.length; i < len; i += 1) {
      btns[i].setAttribute('disabled', 'disabled');
    }
    for (let i = 0, len = inputs.length; i < len; i += 1) {
      inputs[i].setAttribute('disabled', 'disabled');
    }
    // 整列メニューを無効にする
    document.getElementById('headerMenuAlign').classList.add('disabled');
    document.getElementById('btn-item-align-horizontal').classList.add('disabled');
    document.getElementById('btn-item-align-vertical').classList.add('disabled');
  }

  /**
   * コピー
   */
  itemCopy = () => {
    marietta.webcad.WebCADGlobal.itemManager.copyCurrentItemToMemory();
  };

  /**
   * ペースト
   */
  itemPaste = () => {
    marietta.webcad.WebCADGlobal.itemManager.pasteCopiedItem();
  };

  /**
   * 前面・背面移動
   */
  moveFront = (e: Event) => {
    e.preventDefault();
    marietta.webcad.WebCADGlobal.itemManager.moveFront(marietta.webcad.WebCADGlobal.itemManager.currentItem);
    // 保管
    marietta.webcad.WebCADGlobal.webcad2Dmanager.saveToHistory();
  };

  /**
   * move item behind
   */
  moveBack = (e: Event) => {
    e.preventDefault();
    marietta.webcad.WebCADGlobal.itemManager.moveBack(marietta.webcad.WebCADGlobal.itemManager.currentItem);
    // 保管
    marietta.webcad.WebCADGlobal.webcad2Dmanager.saveToHistory();
  };

  /**
   * move item on top
   */
  moveTop = (e: Event) => {
    e.preventDefault();
    marietta.webcad.WebCADGlobal.itemManager.moveTop(marietta.webcad.WebCADGlobal.itemManager.currentItem);
    // 保管
    marietta.webcad.WebCADGlobal.webcad2Dmanager.saveToHistory();
  };

  /**
   * move item behind
   */
  moveBottom = (e: Event) => {
    e.preventDefault();
    marietta.webcad.WebCADGlobal.itemManager.moveBottom(marietta.webcad.WebCADGlobal.itemManager.currentItem);
    // 保管
    marietta.webcad.WebCADGlobal.webcad2Dmanager.saveToHistory();
  };

  /**
   * 回転
   */
  rotateItem = (e: Event) => {
    e.preventDefault();

    let currentItem: marietta.webcad.item.MonicaObject | marietta.webcad.item.GroupItem;
    let angle: number;
    let unit: number = 45;

    if (marietta.webcad.WebCADGlobal.itemManager.currentItem != null && marietta.webcad.WebCADGlobal.itemManager.currentItem !== undefined) {
      currentItem = marietta.webcad.WebCADGlobal.itemManager.currentItem;
      // 階段は90度単位
      if (currentItem instanceof marietta.webcad.item.Stair) {
        unit = 90;
      }

      // アイテムの回転
      angle = currentItem.itemInfo.rotation;
      if ((<HTMLElement>e.currentTarget).getAttribute('id') === 'btnRotateL') {
        angle -= unit;
      } else {
        angle += unit;
      }
      if (angle >= 360) angle %= 360;
      if (angle < 0) angle += 360;
      if (currentItem instanceof marietta.webcad.item.Site) {
        const { itemController } = marietta.webcad.WebCADGlobal.itemManager;
        itemController.rotateItem(angle);
      } else {
        currentItem.rotate(angle);
        currentItem.updateChildren();
      }

      // アイテムコントローラー更新
      marietta.webcad.WebCADGlobal.itemManager.currentItem = currentItem;
    } else if (marietta.webcad.WebCADGlobal.itemManager.currentItemGroup != null && marietta.webcad.WebCADGlobal.itemManager.currentItemGroup !== undefined) {
      currentItem = marietta.webcad.WebCADGlobal.itemManager.currentItemGroup;

      // アイテムの回転
      if ((<HTMLElement>e.currentTarget).getAttribute('id') === 'btnRotateL') {
        currentItem.rotate(-unit);
      } else {
        currentItem.rotate(unit);
      }
    }

    marietta.webcad.WebCADGlobal.webcad2Dmanager.saveToHistory();
    // ライン測定を更新する
    marietta.webcad.WebCADGlobal.updateMeasureLine(false);
  };

  /**
   * 反転
   */
  reverseItem = (e: Event) => {
    e.preventDefault();
    let currentItem: marietta.webcad.item.MonicaObject | marietta.webcad.item.GroupItem;

    if (marietta.webcad.WebCADGlobal.itemManager.currentItem != null && marietta.webcad.WebCADGlobal.itemManager.currentItem !== undefined) {
      currentItem = marietta.webcad.WebCADGlobal.itemManager.currentItem;
      if (marietta.webcad.WebCADGlobal.itemManager.currentItem == null) return;

      if (marietta.webcad.WebCADGlobal.itemManager.currentItem instanceof marietta.webcad.item.WallObject) {
        marietta.webcad.WebCADGlobal.itemManager.currentItem.flipDots();
      } else {
        marietta.webcad.WebCADGlobal.itemManager.currentItem.reverse();
      }

      // アイテムコントローラー更新
      marietta.webcad.WebCADGlobal.itemManager.currentItem = currentItem;
    } else {
      currentItem = marietta.webcad.WebCADGlobal.itemManager.currentItemGroup;
      (currentItem as marietta.webcad.item.GroupItem).flip();
    }

    marietta.webcad.WebCADGlobal.webcad2Dmanager.saveToHistory();
    // ライン測定を更新する
    marietta.webcad.WebCADGlobal.updateMeasureLine(false);
  };

  /**
   * アイテムサイズ変更
   */
  changeItemSize = (e: Event) => {
    if (marietta.webcad.WebCADGlobal.itemManager.currentItem == null) return;

    console.log(e.currentTarget);

    const widthInput = <HTMLInputElement>document.getElementById('itemSizeWidth');
    const heightInput = <HTMLInputElement>document.getElementById('itemSizeHeight');
    const depthInput = <HTMLInputElement>document.getElementById(ITEM_SIZE_DEPTH_INPUT_ID);
    const zInput = <HTMLInputElement>document.getElementById(ITEM_SIZE_Z_INPUT_ID);
    const minPlanSize: number = marietta.webcad.WebCADGlobal.itemManager.currentItem.getMinPlanSizeMM();
    this.clampMinInput(widthInput, minPlanSize);
    this.clampMinInput(heightInput, minPlanSize);

    if (parseInt((<HTMLInputElement>e.currentTarget).value, 10) > marietta.webcad.WebCADGlobal.MAX_SIZE_CHANGE_MONICA) (<HTMLInputElement>e.currentTarget).value = marietta.webcad.WebCADGlobal.MAX_SIZE_CHANGE_MONICA.toString();

    let sizeW = Number(widthInput.value);
    let sizeH = Number(heightInput.value);
    const { currentItem } = marietta.webcad.WebCADGlobal.itemManager;
    // H/Z 欄は対象アイテムのみ反映する。H は他の欄の変更で書き換えないよう、触られたときだけ書く
    if (currentItem.isHeightEditableItem()) {
      if (e.currentTarget === depthInput && !depthInput.disabled) {
        this.clampMinInput(depthInput, MIN_ITEM_HEIGHT_MM);
        currentItem.itemInfo.depth = Number(depthInput.value);
      }
      currentItem.itemInfo.z = this.toInstallationHeight(zInput.value, currentItem.itemInfo.z);
      zInput.value = currentItem.itemInfo.z.toString();
    }

    // mmからpxに変換
    sizeW = marietta.webcad.util.WebCADUtil.convertMMToPix(sizeW);
    sizeH = marietta.webcad.util.WebCADUtil.convertMMToPix(sizeH);

    currentItem.changeSize(sizeW, sizeH, true);

    // アイテムコントローラー更新。選び直してピッカーを新しいサイズで作り直す
    marietta.webcad.WebCADGlobal.itemManager.currentItem = currentItem;

    marietta.webcad.WebCADGlobal.webcad2Dmanager.saveToHistory();
  };

  /**
   * 入力欄の値が下限未満（空欄を含む）なら下限に直す
   */
  private clampMinInput(input: HTMLInputElement, min: number): void {
    if (Number(input.value) < min) input.value = min.toString();
  }

  /**
   * Z欄の入力を設置高さにする。負は 0 で止め、空欄・数値でなければ元の値を保つ
   */
  private toInstallationHeight(input: string, current: number): number {
    const value = parseFloat(input);
    if (Number.isNaN(value)) return current || MIN_INSTALLATION_HEIGHT_MM;
    return Math.max(MIN_INSTALLATION_HEIGHT_MM, value);
  }

  private changeItemHeight = () => {
    const z = Number((<HTMLInputElement>document.getElementById('itemInstallationHeight')).value);
    if (marietta.webcad.WebCADGlobal.itemManager.currentItem.isPinPictureItem()) {
      marietta.webcad.WebCADGlobal.itemManager.currentItem.itemInfo.transformMatrix[13] = z;
    } else {
      marietta.webcad.WebCADGlobal.itemManager.currentItem.itemInfo.z = z;
    }
    marietta.webcad.WebCADGlobal.webcad2Dmanager.saveToHistory();
  }

  /**
   * 色変更
   */
  changeRoomColor = (e: Event) => {
    e.preventDefault();
    marietta.webcad.WebCADGlobal.showDialog(marietta.webcad.view.dialog.RoomFillDialog, true);
  };

  /**
   * 部屋種類変更
   */
  changeRoomType = (e: Event) => {
    e.preventDefault();
    const target = marietta.webcad.WebCADGlobal.showDialog(marietta.webcad.view.dialog.RoomTypeSelection) as marietta.webcad.view.dialog.RoomTypeSelection;
    target.targetRoom = marietta.webcad.WebCADGlobal.itemManager.currentItem as marietta.webcad.item.Room;
    console.log(document.querySelectorAll(`button[value="${target.targetRoom.itemInfo.id}"]`));
    document.querySelectorAll(`button[value="${target.targetRoom.itemInfo.id}"]`).forEach((element) => {
      element.classList.add('selected');
    });
  };

  /**
   * 部屋種類変更
   */
  changeFittingType = (e: Event) => {
    e.preventDefault();
    const target = marietta.webcad.WebCADGlobal.showDialog(marietta.webcad.view.dialog.FittingTypeSelection) as marietta.webcad.view.dialog.FittingTypeSelection;
    target.target = marietta.webcad.WebCADGlobal.itemManager.currentItem as marietta.webcad.item.Fitting;
  };


  /**
   * 部屋名の設定
   */
  showRoomTextSetting = (e: Event) => {
    e.preventDefault();
    marietta.webcad.WebCADGlobal.showDialog(marietta.webcad.view.dialog.RoomTextSetting);
  };

  /**
   * 部屋名の設定
   */
   showItemTextSetting = (e: Event) => {
     e.preventDefault();
     marietta.webcad.WebCADGlobal.showDialog(marietta.webcad.view.dialog.CommonItemTextSetting);
   };

  /**
   * 建具の設定
   */
  showSetting = (e: Event) => {
    e.preventDefault();
    if (this.currentState === 'fitting') {
      const { currentItem } = marietta.webcad.WebCADGlobal.itemManager;
      if (marietta.webcad.WebCADGlobal.isHeightSettingEnableWall(currentItem.itemInfo.id)) {
        marietta.webcad.WebCADGlobal.showDialog(marietta.webcad.view.dialog.WallHeightSettingDialog);
      } else {
        marietta.webcad.WebCADGlobal.showDialog(marietta.webcad.view.dialog.FittingSetting);
      }
    } else if (this.currentState === 'beam') {
      marietta.webcad.WebCADGlobal.showDialog(marietta.webcad.view.dialog.BeamSetting);
    } else if (this.currentState === 'room' || this.currentState === 'group') {
      if( !marietta.webcad.WebCADGlobal.itemManager.currentItem && !marietta.webcad.WebCADGlobal.itemManager.currentItemGroup ) return;
      if( marietta.webcad.WebCADGlobal.itemManager.currentItem ){
        marietta.webcad.WebCADGlobal.showDialog(marietta.webcad.view.dialog.RoomSetting, false, true, true, true, {targetRooms:[marietta.webcad.WebCADGlobal.itemManager.currentItem]} );
      }else{
        marietta.webcad.WebCADGlobal.showDialog(marietta.webcad.view.dialog.RoomSetting, false, true, true, true, {targetRooms:marietta.webcad.WebCADGlobal.itemManager.currentItemGroup.myItemList} );
      }
    }
  };

  /**
   * 汎用作図 文字の設定
   */
  showTextSetting = (e: Event) => {
    e.preventDefault();
    let isPin: boolean = false;
    let isPinPicture: boolean = false;
    let isPinPanorama: boolean = false;
    if (marietta.webcad.WebCADGlobal.itemManager.currentItem !== null && marietta.webcad.WebCADGlobal.itemManager.currentItem !== undefined) {
      isPin = marietta.webcad.WebCADGlobal.isPinTextItem(marietta.webcad.WebCADGlobal.itemManager.currentItem.itemInfo.id);
      isPinPicture = marietta.webcad.WebCADGlobal.isPinPictureItem(marietta.webcad.WebCADGlobal.itemManager.currentItem.itemInfo.id);
      isPinPanorama = marietta.webcad.WebCADGlobal.isPinPanoramaItem(marietta.webcad.WebCADGlobal.itemManager.currentItem.itemInfo.id);
    }

    if( isPinPicture ){
      const param = {
        parentObj: marietta.webcad.WebCADGlobal.itemManager.currentItem,
        view_mode: false,
      };
      marietta.webcad.WebCADGlobal.showDialog(marietta.webcad.view.dialog.PinPictureInfoDialog, false, false, false, false, param);
    }else {
      const param = { isPinText: isPin, isPinPicture: isPinPicture, isPinPanorama: isPinPanorama };
      marietta.webcad.WebCADGlobal.showDialog(marietta.webcad.view.dialog.FreeCharacterInputDialog, false, false, false, false, param);
    }
  };

  /**
   * アイテムのサイズ変更（ダイアログ表示）
   */
  showItemSizeChangeDialog = (e: Event) => {
    e.preventDefault();
    marietta.webcad.WebCADGlobal.showDialog(marietta.webcad.view.dialog.ItemSizeChangeDialog, true);
  };

  /**
   * 削除
   */
  deleteItem = (e: Event) => {
    e.preventDefault();

    // カレントの削除
    if (marietta.webcad.WebCADGlobal.itemManager.currentItem != null && marietta.webcad.WebCADGlobal.itemManager.currentItem !== undefined) {
      marietta.webcad.WebCADGlobal.itemManager.currentItem.deleteMe();
    }

    if (marietta.webcad.WebCADGlobal.itemManager.currentItemGroup != null && marietta.webcad.WebCADGlobal.itemManager.currentItemGroup !== undefined) {
      marietta.webcad.WebCADGlobal.itemManager.currentItemGroup.deleteSelectedItems();
    }
    marietta.webcad.WebCADGlobal.webcad2Dmanager.saveToHistory();
    // パネルを非表示に
    this.ItemControlPanelWrap.style.display = 'none';

    if (marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType === BUILDING_TYPE_MANSION) {
      marietta.webcad.WebCADGlobal.snapManager.updateSnapElements();
    }
  };

  /**
   * 頂点追加モード開始
   */
  startRoomEditAdd = () => {
    (<HTMLElement>document.querySelector('.addPointGuide')).style.display = 'block';
    marietta.webcad.WebCADGlobal.itemManager.editRooms('addPoint');
  };

  /**
   * 壁追加モード開始
   */
  startRoomEditAddWall = () => {
    (<HTMLElement>document.querySelector('.addWallGuide')).style.display = 'block';
    marietta.webcad.WebCADGlobal.itemManager.editRooms('addWall');
  };

  /**
   * 壁削除モード開始
   */
  startRoomEditRemoveWall = () => {
    (<HTMLElement>document.querySelector('.deleteWallGuide')).style.display = 'block';
    marietta.webcad.WebCADGlobal.itemManager.editRooms('removeWall');
  };

  /**
   * 部屋文字の移動
   */
  startRoomTextMove = () => {
    (marietta.webcad.WebCADGlobal.itemManager.currentItem as marietta.webcad.item.Room).overlayText.moveText();
  };

  /**
   * パネルを隠す
   */
  hide() {
    this.ItemControlPanelWrap.style.display = 'none';
  }
}
